/* eslint react-hooks/exhaustive-deps: "warn" */

import { useRouter } from 'next/router';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { StatsBlock } from 'ui/molecules/StatsBlock/StatsBlock';
import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';
import { NumberedStatsSection } from 'ui/organisms/NumberedStatsSection/NumberedStatsSection';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';
import { PillarCards } from 'ui/organisms/PillarCards/PillarCards';

import { AIProductHeroSection } from 'features/agents/organisms/AIProductHeroSection/AIProductHeroSection';
import { AIProductChatDemoSection } from 'features/agents/organisms/AIProductChatDemoSection/AIProductChatDemoSection';
import { AIProductAskSection } from 'features/agents/organisms/AIProductAskSection/AIProductAskSection';
import { AIProductPricingSection } from 'features/agents/organisms/AIProductPricingSection/AIProductPricingSection';
import { AIProductCompareSection } from 'features/agents/organisms/AIProductCompareSection/AIProductCompareSection';
import { AIProductFinalCtaSection } from 'features/agents/organisms/AIProductFinalCtaSection/AIProductFinalCtaSection';

import styles from './AIProductPage.module.scss';

import {
  AI_PRODUCT_DIFFS,
  AI_PRODUCT_FAQ,
  AI_PRODUCT_PROBLEMS,
  AI_PRODUCT_STATS,
  AI_PRODUCT_STEPS,
} from './AIProductPage.data';

const AIProductPage = () => {
  const { asPath } = useRouter();

  return (
    <div className={styles.wrapper}>
      <AIProductHeroSection />
      <OurCustomersV2 background="linear-gradient(180deg, #f9f9f9 0%, #ffffff 100%)" />
      <AIProductChatDemoSection />

      <NumberedFeatureCards
        columns={3}
        title="AI is great. Until you ask it about a real company."
        description="ChatGPT, Claude, Gemini — they're incredible tools. But when it comes to company data, they hit a wall. Here's what happens when you rely on general-purpose AI for business intelligence."
        items={AI_PRODUCT_PROBLEMS}
      />

      <CtaSection
        spotlight
        title="Regis solves all six."
        description="Live registry data. 600M+ companies. Every answer sourced and timestamped. No hallucinations."
        actions={
          <Button
            type="blue"
            size="xl"
            href={`https://platform.globaldatabase.com/public/signup/regis?origin=${process.env.HOST}${asPath}`}
          >
            Get Started Free
          </Button>
        }
      />

      <AIProductAskSection />

      <PillarCards
        glow={false}
        title={
          <>
            Same experience.
            <br />
            Radically better data.
          </>
        }
        description="Regis feels like the AI tools you already use. The difference is what's behind it."
        items={AI_PRODUCT_DIFFS}
        introBlockClassName={styles.diffsIntro}
        bottomContent={<StatsBlock theme="dark" transparent features={AI_PRODUCT_STATS} hasPadding={false} />}
      />

      <NumberedStatsSection title={<>If you{"'"}ve used ChatGPT, you already know how.</>} rows={AI_PRODUCT_STEPS} />

      <AIProductPricingSection />
      <AIProductCompareSection />
      <AIProductFinalCtaSection />
      <Faq title="Frequently asked questions" data={AI_PRODUCT_FAQ} />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default AIProductPage;
